import React, { useState } from "react";
import AdminHeader from "./AdminHeader";
import API_BASE_URL from "./api";
function AdminResultEntry() {
  const [examName, setExamName] = useState("");
  const [jobPost, setJobPost] = useState("");
  const [department, setDepartment] = useState("");
  const [resultDate, setResultDate] = useState("");
  const [resultStatus, setResultStatus] = useState("");
  const [cutOffMarks, setCutOffMarks] = useState("");
  const [meritListLink, setMeritListLink] = useState("");
  const [scoreCardLink, setScoreCardLink] = useState("");
  const [officialNoticeLink, setOfficialNoticeLink] = useState("");

  const buildJson = () => ({
    exam_name: examName,
    job_post: jobPost,
    department: department,
    result_date: resultDate,
    result_status: resultStatus,
    cut_off_marks: cutOffMarks,
    merit_list_link: meritListLink,
    score_card_link: scoreCardLink,
    official_notice_link: officialNoticeLink
  });

  const handleSubmit = async () => {
    try {

        const userEmail = localStorage.getItem("userEmail");
            const user_mobileno = localStorage.getItem("user_mobileno");

            if (!userEmail || !user_mobileno) {
                alert("Login details missing. Please login again.");
                return;
            }

            const payload = {
                ...buildJson(),
                //userEmail: userEmail,
                user_mobileno: user_mobileno
            };

      console.log("SUBMIT PAYLOAD:", payload);
      const response = await fetch(
        `${API_BASE_URL}/api/result/submit`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        }
      );

      const data = await response.json();

      if (data.success) {
        alert("Result inserted successfully");
      } else {
        alert(data.message);
      }
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <AdminHeader />

      <div style={{ padding: "20px", marginTop: "70px" }}>
        <h2>Result Entry</h2>

        <label>Exam Name</label>
        <input
          value={examName}
          onChange={(e) => setExamName(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />

        <label>Job Post</label>
        <input
          value={jobPost}
          onChange={(e) => setJobPost(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />

        <label>Department</label>
        <input
          value={department}
          onChange={(e) => setDepartment(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />

        <label>Result Date</label>
        <input
          type="date"
          value={resultDate}
          onChange={(e) => setResultDate(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />

        <label>Result Status</label>
        <textarea
          value={resultStatus}
          onChange={(e) => setResultStatus(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />

        <label>Cut Off Marks</label>
        <input
          value={cutOffMarks}
          onChange={(e) => setCutOffMarks(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />

        <label>Merit List Link</label>
        <input
          value={meritListLink}
          onChange={(e) => setMeritListLink(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />

        <label>Score Card Link</label>
        <input
          value={scoreCardLink}
          onChange={(e) => setScoreCardLink(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />

        <label>Official Notice Link</label>
        <input
          value={officialNoticeLink}
          onChange={(e) => setOfficialNoticeLink(e.target.value)}
          style={{ width: "100%", padding: 8, marginBottom: 10 }}
        />

        <button
          onClick={handleSubmit}
          style={{
            padding: "10px 20px",
            background: "#28a745",
            color: "#fff",
            border: "none",
            cursor: "pointer"
          }}
        >
          Submit Result
        </button>
      </div>
    </div>
  );
}

export default AdminResultEntry;
